export default __webpack_public_path__ + "static/media/transit.befb75c9.png";